import { render, staticRenderFns } from "./shade.vue?vue&type=template&id=69b31309&scoped=true&"
import script from "./shade.vue?vue&type=script&lang=js&"
export * from "./shade.vue?vue&type=script&lang=js&"
import style0 from "./shade.vue?vue&type=style&index=0&id=69b31309&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b31309",
  null
  
)

export default component.exports